// 사용자 권한 레벨 정의
export enum UserRole {
  A = "a", // 관리자
  AC = "ac", // (core)관리자
  AS = "as", // 운영자
  AS_W = "as_w", // (온보딩 이전)운영자
  U = "u", // 대표사용자
  U_W = "u_w", // (온보딩 이전)대표사용자
  U_E = "u_e", // 만료된 대표사용자
  UC = "uc", // (core)대표사용자
  UC_W = "uc_w", // (온보딩 이전)(core)대표사용자
  US = "us", // 사용자
  US_W = "us_w", // (온보딩 이전)사용자
  US_E = "us_e", // 만료된 사용자
}

// 권한 레벨에 따른 숫자 값 (높을수록 더 많은 권한)

export const ROLE_HIERARCHY: Record<UserRole, number> = {
  [UserRole.A]: 99,
  [UserRole.AC]: 99,
  [UserRole.AS]: 50,
  [UserRole.AS_W]: 50,
  [UserRole.U]: 30,
  [UserRole.U_W]: 30,
  [UserRole.UC]: 30,
  [UserRole.UC_W]: 30,
  [UserRole.US]: 10,
  [UserRole.US_W]: 10,
};

// 권한별 표시 텍스트 (한국어 기준)
export const roleDisplayText = {
  [UserRole.A]: "관리자",
  [UserRole.AC]: "관리자",
  [UserRole.AS]: "운영자",
  [UserRole.AS_W]: "운영자",
  [UserRole.U]: "대표사용자",
  [UserRole.U_W]: "대표사용자",
  [UserRole.U_E]: "대표사용자",
  [UserRole.UC]: "대표사용자",
  [UserRole.UC_W]: "대표사용자",
  [UserRole.US]: "사용자",
  [UserRole.US_W]: "사용자",
  [UserRole.US_E]: "사용자",
} as const;

// 타입 안전한 roleDisplayText 접근 함수
export const getRoleDisplayText = (role: UserRole): string => {
  return roleDisplayText[role] || role;
};

// 권한별 LAB Chip 색상
export const getRoleColor = (role: UserRole): "purple" | "green" | "orange" | "blue" => {
  switch (role) {
    case UserRole.A:
    case UserRole.AC:
      return "purple";
    case UserRole.AS:
    case UserRole.AS_W:
      return "green";
    case UserRole.U:
    case UserRole.U_W:
    case UserRole.UC:
    case UserRole.UC_W:
      return "orange";
    case UserRole.US:
    case UserRole.US_W:
    default:
      return "blue";
  }
};

// Role에 따른 회원 관리 페이지 경로
export const getUsersPagePath = (role: UserRole | string): string => {
  switch (role) {
    case UserRole.A:
    case UserRole.AC:
    case "a":
      return "/users";
    case UserRole.AS:
    case UserRole.AS_W:
    case "as":
      return "/users/business";
    case UserRole.U:
    case UserRole.U_W:
    case UserRole.UC:
    case UserRole.UC_W:
    case "u":
      return "/users/company";
    case UserRole.US:
    case UserRole.US_W:
    default:
      return "/users";
  }
};

// 기본 사용자 데이터 (개발용)
export const defaultUsers = {
  [UserRole.A]: {
    id: "1",
    name: "관리자",
    email: "superadmin@example.com",
    role: UserRole.A,
    avatar: "👑",
    createdAt: new Date("2024-01-01"),
  },
  [UserRole.AS]: {
    id: "2",
    name: "운영자",
    email: "admin@example.com",
    role: UserRole.AS,
    avatar: "️",
    createdAt: new Date("2024-01-02"),
  },
  [UserRole.U]: {
    id: "3",
    name: "사업자",
    email: "premium@example.com",
    role: UserRole.U,
    avatar: "⭐",
    createdAt: new Date("2024-01-03"),
  },
  [UserRole.US]: {
    id: "4",
    name: "사용자",
    email: "user@example.com",
    role: UserRole.US,
    avatar: "👤",
    createdAt: new Date("2024-01-04"),
  },
} as const;

// 개발용 헬퍼 함수들
export const getDefaultUser = (role: UserRole) => defaultUsers[role];

export const getAllDefaultUsers = () => Object.values(defaultUsers);
